import { useEffect, useState } from "react";
import { getKnowledgeArticles } from "../../../utils/AWSAPI";
import { Link } from "react-router-dom";
import LoadingSpinner from "../../../utils/LoadingSpinner";
import '../../../assets/css/KBArticles.css'
import { useTranslation } from 'react-i18next'; 
import i18n from "../../Translations/i18n/i18n";  //import i18next


function KBArticles() {
  // DATA API
  const [isLoading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  // Are we showing a modal? I.E: Error, success.
  const [isModalShowing, setModalShowing] = useState(false);
  const [isModalUncloseable, setModalUncloseable] = useState(false);

  const [modalHeader, setModalHeader] = useState('Loading...');
  const [modalBody, setModalBody] = useState(<></>);
  const [modalFooter, setModalFooter] = useState(<></>);

  const closeModal = () => {
    setModalShowing(false);
  };
  
  const { t } = useTranslation();

  const Modal = () => {
    return (
      <form>
        <div className="modal show">
          <div className="modal-content">
            <div className="modal-header">
              <h4>{modalHeader}</h4>
              {!isModalUncloseable && (
                <span className="close" onClick={closeModal}>&times;</span>
              )}
            </div>
            <div className="modal-body">{modalBody}</div>
            <div className="modal-footer">{modalFooter}</div>
          </div>
        </div>
      </form>
    );
  };

  const updateModal = (header, body, footer) => {
    setModalShowing(!isModalShowing);
    setModalHeader(header);
    setModalBody(body);
    setModalFooter(footer);
  }
  
  const setDefaultAttributes = async () => {
    const url = new URL(window.location.href);
    const categoryValue = url.searchParams.get('category');

    setModalFooter(<></>)

    if (!categoryValue) {
      updateModal(t('whoops'), t('invalidArticle'));
      return { success: false };
    } else {
      return { success: true, category: categoryValue };
    }
  };

  useEffect(() => {
    const loadLanguage = () => {
      const language = localStorage.getItem("language");
      if (language) {
        i18n.changeLanguage(language);
      }
    };
    loadLanguage();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { success, category: fetchedCategory } = await setDefaultAttributes();
        if (success) {
          const categoryData = await getKnowledgeArticles(fetchedCategory, localStorage.getItem("language"));
          if (categoryData.Error) {
            return updateModal("Error", categoryData.Error)
          }
          setData(categoryData);
          setLoading(false);
        } else {
          console.log("Invalid category. Not calling API.");
        }
      } catch (err) {
        console.log(err);
      }
    };
    if (isLoading) {
      fetchData();
    }
  }, [isLoading]);

  return (
    <div className="App">
      <LoadingSpinner show={isLoading} />

      {!isLoading && isModalShowing && (
        <Modal />
      )}
      
      {data && (
        <div className="container">
          {data.map((article, index) => (
            <Link to={"/knowledge/article?articleId=" + article.sys_id} key={index} style={{ display: "contents" }}>
              <button className="article">
                <div className="bookmark"></div>
                <b>{article.number}</b>
                <br />
                {article.short_description}
              </button>
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}

export default KBArticles;